// 回饋明細「點姓名查住客」的純資料判斷。刻意不 import antd/axios，測試才跑得動
// (慣例同 feedbackItem.js)。

// 不可用「姓名」：問卷另有一題「…(服務態度優良人員的姓名或部門)」，答案是服務人員
// 的名字。「行動電話」只出現在住客聯絡資料這一題 (與後端 SurveyGuestHints 同一條規則)。
const CONTACT_MARKER = "行動電話";

export function isGuestContactQuestion(subject) {
  return String(subject || "").includes(CONTACT_MARKER);
}

// 順序與後端 GuestLookup::REASONS 相同：房號日期直接定位到那一次住宿，最可靠
const REASON_LABELS = {
  stay: "房號日期相符",
  phone: "手機相符",
  booker_phone: "訂房人手機相符",
  name: "姓名相符",
  booker_name: "訂房人姓名相符",
};

export function reasonLabel(reason) {
  return REASON_LABELS[reason] || reason;
}

/** 後端只給末 3 碼，補上遮罩讓人一眼看出這是不完整的號碼 */
export function maskedPhone(tail) {
  return tail ? `***${tail}` : "—";
}

/** 通路類型 (網路旅行社) 與訂房來源 (Booking)，兩者合起來才看得出是哪個平台 */
export function channelText(visit) {
  const parts = [visit.source_nam, visit.cust_nam].filter(Boolean);
  return parts.length ? parts.join("・") : "—";
}
